import { callService } from "@Views/utils/ServiceUtils";
import { useEffect } from "react";
import i18n from '@Lang/i18n';
import { useHistory, useParams } from "react-router";

const ShortLink = ({ msg }: any) => {

    const params: any = useParams();
    const history = useHistory();

    const selectShortUrl = async () => {
        if (params['shortUrl']) {
            const res = await callService("OSUUA04R01", { shortUrl: '/#/Short/' + params['shortUrl'] });
            if (res && res['sdShortUrlMngMList'] && res['sdShortUrlMngMList'].length !== 0) {
                const shortUrlItem = res['sdShortUrlMngMList'][0];

                if (i18n.language.toUpperCase() !== shortUrlItem['langCd']) {
                    i18n.changeLanguage(shortUrlItem['langCd'].toLowerCase());
                }

                history.replace({ pathname: shortUrlItem['lkdScrId'], state: JSON.parse(shortUrlItem['inptItmCtnt']) });
            } else {
                history.replace("/");
            }
        }
    }
    useEffect(() => {
        selectShortUrl();
    }, [])

    return (
        <>

        </>
    );
}


export default ShortLink;